export default __webpack_public_path__ + "static/media/image.innovation-quotient.9e173e76.png";